export const OVERVIEW_EVENTS = {
    GOAL: "GOAL",
    PENALTY_GOAL: "PENALTY_GOAL", // one penalty goal in the game
    PENALTY_SAVED: "PENALTY_SAVED",
  
    YELLOW_CARD: "YELLOW_CARD",
    CORNER: "CORNER",
    INJURY_BREAK: "INJURY_BREAK",
    OFFSIDE: "OFFSIDE",
    PENALTY_AWARDED: "PENALTY_AWARDED",
    PENALTY_MISSED: "PENALTY_MISSED",
    RED_CARD: "RED_CARD",
    SHOT_OFF_THE_TARGET: "SHOT_OFF_THE_TARGET",
    SHOT_ON_THE_TARGET: "SHOT_ON_THE_TARGET",
    SUBSTITUTE: "SUBSTITUTE",
    VAR_CHECK: "VAR_CHECK",
    VAR_DECLINED: "VAR_DECLINED",
    VAR: "VAR",
    OWN_GOAL: "OWN_GOAL",
    MATCH_ENDED: "MATCH_ENDED",
    HALF_TIME: "HALF_TIME",
    FULL_TIME: "FULL_TIME",
    EXTRA_TIME: "EXTRA_TIME",
    PENALTIES: "PENALTIES", 
    PENALTIES_GOAL: "PENALTIES_GOAL", //penalty series goal after extra time
    PENALTIES_MISSED: "PENALTIES_MISSED", //penalty series missed after extra time
    PENALTIES_SAVED: "PENALTIES_SAVED", //penalty series saved after extra time
    ADDED_TIME: "ADDED_TIME",
    SECOND_YELLOW_CARD: "SECOND_YELLOW_CARD"
}

export const DESCRIPTION_TYPES = {
    GOAL: "GOAL",
    PENALTY: "PENALTY"
}

export const VAR_EVENTS = {
    VAR: "VAR",
    VAR_CHECK: "VAR_CHECK",
    VAR_DECLINED: "VAR_DECLINED"
}


export const VAR_EVENTS_LABELS = {
    VAR_GOAL: "Goal check",
    VAR_CHECK_GOAL: "Goal confirmed",
    VAR_DECLINED_GOAL: "No goal",
    VAR_PENALTY: "Penalty check",
    VAR_CHECK_PENALTY: "Penalty confirmed",
    VAR_DECLINED_PENALTY: "No penalty",
    EMPTY: ""
}

export const ActiveFilterName = {
    FULL_MATCH: 'full_match',
    FIRST_HALF: 'first_half',
    SECOND_HALF: 'second_half',
    OVERTIME: 'overtime',
} as const;
export type ActiveFilterName = (typeof ActiveFilterName)[keyof typeof ActiveFilterName];


export const SCPlayersActiveFilterName ={
    GOALS: 'goals',
    ASSISTS: 'assists',
    CARDS: 'cards',
    SHOTS: 'shots',
} as const;
export type SCPlayersActiveFilterName = (typeof SCPlayersActiveFilterName)[keyof typeof SCPlayersActiveFilterName];


export const H2HActiveFilterName = {
    H2H: 'h2h',
    TABLE: 'table',
    QUARTER_FINALS: 'quarter_finals',
    ROUND_OF_16: 'round_of_16',
    KNOCKOUT: 'knockout',
    QUALIFICATION: 'qualification',
    GROUPS_TABLES: 'groups_tables',
} as const;
export type H2HActiveFilterName = (typeof H2HActiveFilterName)[keyof typeof H2HActiveFilterName];

export { UrlParams, T, Version } from '@/common/enums'; //TODO: remove export, import directly from common, need add this to backlog

export const SCLineupPlayersActiveFilterName = {
    XGOALS: 'xGoals',
    SHOTS: 'shots',
    BALL_TOUCHES: 'ballTouches',
    NULL: '',
} as const;
export type SCLineupPlayersActiveFilterName = (typeof SCLineupPlayersActiveFilterName)[keyof typeof SCLineupPlayersActiveFilterName];

export const DefaultStatsConsoleTab = {
    STATS: 'Stats',
    OVERVIEW: 'Overview',
    PLAYERS: 'Players',
    LINEUP: 'Lineup',
    H2H: 'H2H',
} as const;
export type DefaultStatsConsoleTab = (typeof DefaultStatsConsoleTab)[keyof typeof DefaultStatsConsoleTab];
